export default "__VITE_PUBLIC_ASSET__12b07f8d__"